import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'

/**
 * Runs when the router meta.middleware is 'unauthenticated'
 * force to replace route to index if authenticated
 * @param ctx
 */
export function beforeEnter(ctx: MiddlewareContext<App, RootState>) {
  const {
    sales_id, utm_source, utm_medium, ref_code,
    match_token, utm_campaign, company_name, business_number,
  } = ctx.to.query
  if(sales_id) {
    localStorage.setItem('sales_id', sales_id.toString())
  }
  if(utm_source) {
    localStorage.setItem('utm_source', utm_source.toString())
  }
  if(utm_medium) {
    localStorage.setItem('utm_medium', utm_medium.toString())
  }
  if(utm_campaign) {
    localStorage.setItem('utm_campaign', utm_campaign.toString())
  }
  if(ref_code) {
    localStorage.setItem('ref_code', ref_code.toString())
  }
  if(match_token) {
    localStorage.setItem('match_token', match_token.toString())
  }
  // 외부 제휴사 배너 유입 시 회사 정보를 회원가입 form에 prefill하기 위해 저장.
  // Biz.vue created()에서 라우트(sign-up-biz)를 기준으로 prefill 여부를 결정한다.
  if(company_name) {
    localStorage.setItem('company_name', company_name.toString())
  }
  if(business_number) {
    localStorage.setItem('business_number', business_number.toString())
  }
  if(!ctx.store) {
    throw new Error('[authenticated] middleware should have the store')
  }
  const authenticated = ctx.store.getters['auth/authenticated']
  if(authenticated) {
    ctx.store?.dispatch('users/postUserUtm')
    ctx.next(ctx.store.getters['auth/failbackMain'])
    return
  }
  return ctx.next()
}
